import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconX } from '@tabler/icons-react';
import { createStyles } from '@mantine/core';
import { useActivityTracker } from '../hooks/useActivityTracker';
import { getUserType, getUserData } from '../config/userSession';
const useSessionTimeout = (onLogout) => {
  const navigate = useNavigate();
  const { trackEvent } = useActivityTracker();
  const userDetails = getUserData();
  const userType = getUserType();

  const showNotification = (notificationType, message, title, width) => {
    let colorCode = notificationType === 'success' ? 'secondary.0' : 'red';

    notifications.show({
      id: 'plan-edit-notification',
      withCloseButton: true,
      title: title,
      message: message,
      autoClose: false,
      color: colorCode,
      icon:
        notificationType === 'success' ? (
          <IconCheck size="2.5rem" />
        ) : (
          <IconX size="2.5rem" />
        ),
      style: {
        backgroundColor: '#e1f4f5',
        padding: '12px 12px',
        fontSize: '8rem',
        lineHeight: '1.2',
        minHeight: '120px',
        width: width, // 👈 Set desired width here
        maxWidth: '90%' // Optional: responsive on smaller screens
      },
      styles: {
        title: {
          fontSize: '1.5rem',
          lineHeight: 1.3
        },
        description: {
          fontSize: '1.2rem',
          lineHeight: 1.4
        },
        closeButton: {
          color: 'white',
          backgroundColor: 'black',
          '&:hover': {
            backgroundColor: 'gray', // Change to your preferred hover color
            color: 'yellow' // Example hover text color
          }
        }
      }
    });
  };

  const handleOnIdle = async () => {
    const isLoggedIn = sessionStorage.getItem('loggedIn') === 'true';
    if (!isLoggedIn) return;
    sessionStorage.removeItem('loggedIn');
    showNotification(
      'failed',
      'You have been logged out due to 15 minutes of inactivity.',
      '',
      '450px'
    );
    await trackEvent('session-expired', {
      userType,
      userEmail: userDetails.email,
      message: 'user logged out due to inactivity'
    });
    onLogout();
    navigate('/login');
  };

  useIdleTimer({
    timeout: 15 * 60 * 1000,
    onIdle: handleOnIdle,
    debounce: 500
  });

  return null;
};

export default useSessionTimeout;
